// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6345":"14af1b9ff26c2c09","6537":"4e58fd167ec646ad"}[chunkId] + ".css";
};